<header class="header toptoscroll">
  <!--Secodary Header-->
 
  <div class="primary-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 col-xs-12">

          <nav class="navbar navbar-expand-xl navbar-light bg-light">
            <a href="#" class="navbar-brand">
              <h4 class="logotext">
                <!-- GovTow Auctions -->
                <img src="assets/img/logo-web.png">
              </h4>
            </a>      
            <button type="button" class="navbar-toggler collapsed" data-toggle="collapse" aria-expanded="false"
              aria-label="false" data-target="#navbarCollapse">
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarCollapse" [ngClass]="{ 'show': navbarOpen }">
              <ul class="navbar-nav" *ngFor="let nv of menuList">
                <span *ngIf="hideShow(nv.URL) == true">
                  <li *ngIf="nv.children.length == 0">
                    <a class="nav-item nav-link collapsed" data-toggle="collapse" data-target=".navbar-collapse.show"
                      routerLink="/{{nv.URL}}"
                     
                      (click)="topNavClick(nv)">
                      <span *ngIf="nv.Description=='Dashboard'">
                        <i class="fas fa-th-large fa-lg"></i>
                      </span>
                      <span *ngIf="nv.Description!='Dashboard'">{{nv.Description}}</span>
                      <!-- {{nv.Description}} -->
                    </a>
                  </li>
                  <li class="nav-item dropdown" *ngIf="nv.children && nv.children.length > 0">
                    <a data-toggle="dropdown" class="nav-link dropdown-toggle collapsed">{{nv.Description}}</a>
                    <ul class="dropdown-menu">
                      <li *ngFor="let subMenu of nv.children">
                        <a routerLink="/{{subMenu.URL}}" class="dropdown-item collapsed" data-toggle="collapse"
                          data-target=".navbar-collapse.show">{{subMenu.Description}}</a>
                      </li>
                    </ul>
                  </li>
                  <!-- <li *ngIf="nv.URL == 'register' && roleId==4">
                    <a class="nav-item nav-link collapsed" data-toggle="collapse" data-target=".navbar-collapse.show"
                      routerLink="/{{nv.URL}}" (click)="topNavClick(nv)">
                      {{nv.Description}}
                    </a>
                  </li> -->
                  <!-- <li class="nav-item dropdown" *ngIf="nv.URL == 'sellerconfig'">
                    <a data-toggle="dropdown" class="nav-link dropdown-toggle collapsed">Config </a>
                    <ul class="dropdown-menu">
                      <li *ngFor="let subMenu of nv.children">
                        <a routerLink="{{subMenu.URL}}" class="dropdown-item collapsed" data-toggle="collapse" data-target=".navbar-collapse.show">{{subMenu.Description}}</a>
                      </li>
                    </ul>
                  </li> -->
                  
                  <!-- <li class="nav-item dropdown" *ngIf="nv.URL == 'editprofile'">
                    <a class="nav-link dropdown-toggle collapsed" data-toggle="dropdown">Profiles </a>
                    <ul class="dropdown-menu">
                      <li>
                        <a routerLink="/editprofile" class="dropdown-item collapsed" data-toggle="collapse"
                          data-target=".navbar-collapse.show">Profile</a>
                      </li>
                      <div class="dropdown-divider"></div>
                      <li>
                        <a routerLink="/paymentprofile" class="dropdown-item collapsed" data-toggle="collapse"
                          data-target=".navbar-collapse.show">Payments</a>
                      </li>
                      <div class="dropdown-divider"></div>
                      <li>
                        <a routerLink="/bidderapprovalrequest" class="dropdown-item collapsed" data-toggle="collapse"
                          data-target=".navbar-collapse.show">Bid Registration</a>
                      </li>
                      <div class="dropdown-divider"></div>
                     
                      <li *ngIf="groupName == 'Bidder'">
                        <a routerLink="/notification" class="dropdown-item collapsed" data-toggle="collapse"
                          data-target=".navbar-collapse.show">Config Notification</a>
                      </li>
                      <div class="dropdown-divider"></div>
                     
                      <li *ngIf="groupName!='Enterprise'">
                        <a routerLink="/changepassword" class="dropdown-item collapsed" data-toggle="collapse"
                          data-target=".navbar-collapse.show">Change Password</a>
                      </li>
                    </ul>
                  </li> -->
                  <!-- <li class="nav-item dropdown" *ngIf="nv.URL == 'vehiclelist'">
                    <a data-toggle="dropdown" class="nav-link dropdown-toggle collapsed">Pre Auction Sheet </a>
                    <ul class="dropdown-menu">
                      <li>
                        <a routerLink="/vehiclelist" class="dropdown-item collapsed" data-toggle="collapse"
                          data-target=".navbar-collapse.show">Pre Auction</a>
                      </li>
                     
                      <ng-template [ngIf]="!IsDLMS">
                        <li *ngFor="let subMenu of nv.children">
                          <a routerLink="{{subMenu.URL}}" [queryParams]="{ from:'menu_item' }"
                            class="dropdown-item collapsed" data-toggle="collapse"
                            data-target=".navbar-collapse.show">{{subMenu.Description}}</a>
                        </li>
                      </ng-template>
                    </ul>
                  </li> -->
                  <!-- <li class="nav-item dropdown" *ngIf="nv.Description == 'Settings' && roleName=='Admin'">
                    <a data-toggle="dropdown" class="nav-link dropdown-toggle collapsed">{{nv.Description}}</a>
                    <ul class="dropdown-menu">
                      <li *ngFor="let subMenu of nv.children">
                        <a routerLink="{{subMenu.URL}}" class="dropdown-item collapsed" data-toggle="collapse"
                          data-target=".navbar-collapse.show">{{subMenu.Description}}</a>
                      </li>
                    </ul>
                  </li>
                  <li *ngIf="nv.URL == 'changepassword' && groupName=='Enterprise'">
                    <a routerLink="/{{nv.URL}}" class="nav-item nav-link collapsed" data-toggle="collapse" data-target=".navbar-collapse.show">{{nv.Description}}</a>
                  </li>                  -->
                </span>

              </ul>
              
              
              <ul class="navbar-nav navbar-right ml-auto" *ngIf="isLoggedIn == true">
                <li class="mr-3 dropdown">
                  <a class="notification" data-toggle="dropdown">
                    <span>
                      <i class="fas fa-bell fa-lg"></i>
                    </span>
                    <span class="badge" *ngIf="notification.length > 0">{{notification.length}}</span>
                  </a>
                  <!-- <ul class="dropdown-menu" *ngIf="staticMsg.length > 0">
                    <li *ngFor="let item of staticMsg">
                      {{item.text}}
                    
                    </li>
                  </ul> -->
                 
                  <ul class="dropdown-menu dropdown-dynamic" *ngIf="notification.length > 0" >
                    <li *ngIf="staticMsg.length > 0"><p class="static-para" *ngFor="let item of staticMsg">{{item.text}}</p></li>
                    <!-- <li>
                      <p class="static-para">Static Message NET is a free, cross-platform, open-source developer platform. .NET has languages, editors, and libraries to build for web, mobile, desktop, games, and IoT. </p>
                    </li>  -->
                     <div *ngIf="dynamicMsg.length > 0">
                      <div class="pull-right" >
                        <button class="btn btn-default btn-delete" type="button"  style="color:red"  (click)="clearusernotificatio(this.UserId)"><i class="fas fa-trash"></i></button>
                    </div>
                      <li *ngFor="let item of dynamicMsg">
                        <p class="msg-para">{{item.text}}</p>
                        <!-- <div class="dropdown-divider"></div> -->
                      </li>
                     </div>
                    
                    
                  </ul>
                  <ul class="dropdown-menu" *ngIf="notification.length == 0">
                    <li style="padding: 5px;font-size: 1rem;">Not available</li>
                  </ul>
                </li>
                <li class="dropdown">
                  <a href="#" class="nav-link nav-user dropdown-toggle user collapsed" data-toggle="dropdown">
                    {{currentUser?.username}}&nbsp;&nbsp;
                    <img class="img-profile rounded-circle" src="assets/img/no-photo-img.png">
                    <!-- <span class="text-warning" data-toggle="tooltip" data-placement="top"
                      title="Bidder #" *ngIf="currentUser?.bidderno">({{currentUser?.bidderno}})</span> -->
                  </a>
                  <ul class="dropdown-menu">
                    <!-- <li><a class="nav-link" routerLink="/editprofile">Profile</a></li>                    
                    <li><a class="nav-link" href="#">Payments</a></li>                   
                    <li><a class="nav-link" href="#">Change Password</a></li>
                    <div class="dropdown-divider"></div> -->
                    <li>
                      <a class="nav-link collapsed" (click)="logout()" title="Logout" style="color:red;">
                        <i class="fas fa-sign-out-alt"></i> Signout</a>
                    </li>
                  </ul>
                </li>
              </ul>
            
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <!--Primary Header-->
  <!-- <div class="primary-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 col-xs-12">

          <div class="header-branding">
            <a href="#" class="header-logo">
              <img src="logo.png" alt="" />
            </a>
          </div>

          <div class="header-primary-inner">
            <div class="sign-in" *ngIf="isLoggedIn == false">
              <a routerLink="/login">Login</a>
              <span class="or">or</span>
              <a routerLink="/register">Register</a>
            </div>
            <div class="user" *ngIf="isLoggedIn == true">
              {{currentUser?.username}} &nbsp;
             <span> 
               <a class="btn btn-user btn-circle" (click)="logout()" title="Logout">
                <i class="fas fa-sign-out-alt"></i>
              </a>
              </span>
            </div>
            
            <ul class="nav nav-desktop">
              <span *ngFor="let nv of menuList">
                <li class="nav__item" *ngIf="hideShow(nv.URL) == true">
                  <a class="nav__link" routerLink="/{{nv.URL}}">{{nv.Description}}</a>
                </li>
              </span>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div> -->

</header>
<div class="conainer-fluid" *ngIf="isLoggedIn == true && roleName == 'Bidder'">
  <div class="row">
    <div class="col-md-12 col-xs-12 text-center mt-3 border-bottom pb-2" style="font-weight:600; font-size:18px;">
      Bidder#:
      <span class="text-success">{{currentUser?.bidderno}}</span>
    </div>
  </div>
</div>

<div *ngIf="isLoggedIn == true && groupName == 'Enterprise'">
  <!-- Location: <span class="text-success">{{LocationName}}</span> -->
  <form [formGroup]="storagelotForm" class="form-inline">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 col-xs-12 text-center">
          <div class="mt-3 mx-auto mb-2">
            <label class="d-inline mx-3">Location</label>
            <select class="form-control customDropdown" formControlName="StorageLotFormControl"
              [ngClass]="{ 'is-invalid': lotsubmitted && fl.StorageLotFormControl.errors }"
              (change)="onStorageLotChange()">
              <option *ngFor="let x of StorageLotList" [ngValue]="x" class="text-success">
                {{ x.StorageLocationName }} {{ x.VSFNum ? '(' + x.VSFNum + ')' : '' }}
              </option>
            </select>
            <!-- {{ x.StorageLocationName}}  {{x.VSFNum ? (x.VSFNum) : null}} -->
            <div *ngIf="lotsubmitted && fl.StorageLotFormControl.errors" class="invalid-feedback">
              <div *ngIf="fl.StorageLotFormControl.errors.required">This is required</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>